<template>
    <c-dialog ref="dialog" height="350" width="450" @resolve="save">
        <c-form ref="form">
            <c-form-item label="渠道图标">
                <c-upload-file filePath="quote" name="icon_url" type="image" size="1024"></c-upload-file>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name: 'channelIconEdit',

    data() {
        return {
            channelId: null,
            saving: false,
        };
    },

    methods: {
        open(data) {
            this.channelId = data.id;
            this.saving = false;
            this.$refs.dialog.open({title: '配置图标 - ' + data.channel_name});
            this.$nextTick(() => this.$refs.form.set({icon_url: data.icon_url || ''}));
        },

        save(stop, next) {
            stop();
            if (this.saving) return;
            this.saving = true;
            this.request({
                url: '/channel/icon/edit',
                data: {
                    id: this.channelId,
                    icon_url: this.$refs.form.get().icon_url || '',
                },
                loading: true,
                success: () => {
                    this.saving = false;
                    next();
                    this.$message({message: '渠道图标保存成功', type: 'success'});
                    this.$emit('resolve');
                },
                fail: () => {
                    this.saving = false;
                },
            });
        },
    },
};
</script>
